import { Box } from "@mui/material";
import ColorPicker from "../ColorPicker";
import { BackForeColor } from "./BackForeColor";
import localize from "../../common/localize";

export default function BackgroundForegroundColorPicker({
  backgroundValue,
  foregroundValue,
  onChange,
  backgroundName = "BackgroundColor",
  foregroundName = "ForegroundColor",
  backgroundLabel = localize.background_color,
  foregroundLabel = localize.foreground_color,
  previewText = localize.text,
  className = "w-full flex justify-between gap-2 mt-2 items-center",
}) {
  return (
    <Box className={className}>
      <Box className="flex gap-2 items-center">
        <ColorPicker
          id="bg-color-picker"
          value={backgroundValue}
          name={backgroundName}
          onChange={onChange}
          labelText={backgroundLabel}
        />

        <ColorPicker
          id="fg-color-picker"
          value={foregroundValue}
          name={foregroundName}
          onChange={onChange}
          labelText={foregroundLabel}
        />
      </Box>

      <Box sx={{ width: "100px" }}>
        <BackForeColor
          backColor={backgroundValue}
          foreColor={foregroundValue}
          styleName="text-xs"
          text={previewText}
        />
      </Box>
    </Box>
  );
}
